import { Box, Heading, Text, Image,HStack, Flex, SimpleGrid } from '@chakra-ui/react';
import TermsConditions from '../Components/TermsConditions';
import ParentLayout from './ParentLayout';
import NavBarParent from './NavBarParent';

const TermsAndConditionsParent = () => (
    <Box>
    <NavBarParent />
  <ParentLayout>
      <Box bgColor={"black"} textColor={"white"} p={4}>
<TermsConditions />
      </Box>
  </ParentLayout>
  </Box>
);

export default TermsAndConditionsParent;